module.exports = __webpack_public_path__ + "static/digital459e1153d78374c2aa77a833e2139df00.png";